import React, { createContext, useState } from 'react';

// Create a Context
const AppContext = createContext({});

export default AppContext;